import { siteDevelopmentUrl } from "../../utility/Index";

export const gettingStartedData = {
  GettingStarted: {
    Title: "Getting Started",
    GeneralTopData: [
      "Welcome to Our Platform! 🚀",
      "Follow these simple steps to get started:",
    ],
    GeneralBottomData: [
      "Enjoy the Competition and Good Luck! 🏆",
      "Feel free to explore and start your first challenge or event now!",
    ],
    Players: {
      Steps: [
        {
          StepTitle: "Step 1: Sign Up and Log In",
          Description: [
            "Sign Up: Enter your email, create a password, and verify your account.",
            "Log In: Use your credentials to access your dashboard.",
          ],
        },
        {
          StepTitle: "Step 2: Purchase Tokens",
          Description: [
            `<a href='${siteDevelopmentUrl}/PurchaseScreen'>Buy Tokens</a>: Add tokens to your account using real money.`,
            "Use Tokens: Purchase bronze belts with your tokens.",
          ],
        },
        {
          StepTitle: "Step 3: Challenge and Compete",
          Description: [
            `<a href='${siteDevelopmentUrl}/CreatePublicEventScreen?eventType=Public'>Kall Out</a>: Challenge other users in your favorite games.`,
            "Set Wager: Choose the number of belts or use coins to wager.",
            "Set Rules: Organizers set the initial rules of play for the game.",
            "Change Rules: Chat with your opponent to change rules, but changes must be made before finalizing the challenge.",
            "Set Time and Date: Schedule the challenge at a convenient time for both players.",
            "Stream the Event: Set up to stream the event via Twitch or YouTube.",
            "Share the Event: Share the event with your social profile audience or followers to receive gifts during the event.",
            "Play: Go to your chosen device, play the game, and win!",
          ],
        },
        {
          StepTitle: "Step 4: Exclusive Events",
          Description: [
            "Create Event: Organizers set up ticketed events for exclusive live streaming.",
            "Sell Tickets: Define ticket prices and attendee requirements.",
            "Stream Live: Host the event and engage with your audience.",
          ],
        },
        {
          StepTitle: "Step 5: Submit Results",
          Description: [
            "Select Winner: Both players agree on who won.",
            "Disagreement: If there's a dispute, both players submit their results for review in the Dispute Center with a screenshot of the winner.",
            "Chance Limitation: Players have 3 chances to select the correct winner. After 3 incorrect self-selections, players will be suspended for a period.",
          ],
        },
        {
          StepTitle: "Step 6: Progress and Redeem",
          Description: [
            "Win Belts: Win 10 bronze belts to advance to silver, 10 silver belts to advance to gold, and 10 gold belts to advance to platinum.",
            "Redeem Belts: Convert silver and above belts into credits for real money payouts.",
          ],
        },
        {
          StepTitle: "Step 7: Stay Connected",
          Description: [
            "Social Feed: Follow the latest challenges and events.",
            "Engage: Like, comment, and share to stay involved in the community.",
          ],
        },
      ],
    },
    Audience: {
      Steps: [
        {
          StepTitle: "Step 1: Sign Up to Watch",
          Description: [
            "Sign Up: Create an account to watch events and support players.",
          ],
        },
        {
          StepTitle: "Step 2: Purchase Tokens",
          Description: [
            "Buy Tokens: Add tokens to your account using real money.",
            "Use Tokens: Purchase gifts with tokens.",
          ],
        },
        {
          StepTitle: "Step 3: Donate Gifts",
          Description: [
            "Select Stream: Choose a stream to watch.",
            "Give Gifts: Use tokens to send exciting gifts to your favorite players during the stream.",
          ],
        },
        {
          StepTitle: "Step 4: Exclusive Events",
          Description: [
            "Buy Tickets: Use tokens to buy tickets for exclusive events.",
            "Stream Live: Watch live streams of exclusive events and engage with your favorite players.",
          ],
        },
        {
          StepTitle: "Step 5: Stay Connected",
          Description: [
            "Follow the latest challenges and events.",
            "Engage: Like, comment, and share to stay involved in the community.",
          ],
        },
      ],
    },
  },
};
